import { parse } from "url";

/**
 * Parses a URL string and extracts the query parameters as an object.
 *
 * @param {string} url - The URL string to parse.
 * @param {Single} [single] - If `true`, ensures that array values return only the first element as a string.
 *
 */
export const parseQuery = <Single extends boolean | undefined>(url: string, single?: Single) =>
  Object.fromEntries(
    Object.entries(parse(url, true).query).map(([key, val]) => [
      key,
      (single && Array.isArray(val) ? val[0] : val) as Single extends true ? string : string[],
    ])
  );
